import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './assets/images/portal_logo.png';
const _hoisted_1 = {
    key: 1,
    class: "fullscreenCenteredContainer"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    class: "mb-3"
}, null, -1);
const _hoisted_3 = { class: "notification bulmaNotification is-danger" };
const _hoisted_4 = {
    key: 2,
    class: "appContainer"
};
import { onMounted, ref } from "vue";
import { loadConfig, CONFIG, MaintenanceMode } from "./core/config";
import { tryToResumeSession } from "./core/session";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const initializing = ref(true);
        onMounted(() => {
            loadConfig();
            // Try to resume cached session, if any
            tryToResumeSession()
                .catch(err => {
                // Swallow session-resume errors - it's not unusual to encounter e.g. an expired session
                console.log("Failed to resume session");
            })
                .finally(() => {
                initializing.value = false;
            });
        });
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_router_view = _resolveComponent("router-view");
            return (initializing.value || !_unref(CONFIG))
                ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                : (_unref(CONFIG).maintenanceMode == _unref(MaintenanceMode).CLOSED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(CONFIG).maintenanceMessage), 1)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(), _createBlock(_component_router_view, {
                            key: _ctx.$route.fullPath
                        }))
                    ]));
        };
    }
});
